import { render, staticRenderFns } from "./my-game-money.vue?vue&type=template&id=f71fe8cc&scoped=true&"
import script from "./my-game-money.vue?vue&type=script&lang=js&"
export * from "./my-game-money.vue?vue&type=script&lang=js&"
import style0 from "./my-game-money.vue?vue&type=style&index=0&id=f71fe8cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71fe8cc",
  null
  
)

export default component.exports